import { UserPhotos } from "../components/NavigationBar/types";
import { ClubPhoto } from "../components/NavigationBar/types";
import { AllClubPhotos } from "../components/NavigationBar/types";

const getValidClubName = (str: string) => {
  return str.replace(/\s/g, '-')
}

export const getUserAvatar = (userId: string): string => {
  return `${process.env.REACT_APP_MEDIA_URL}${userId}`;
};

export const getAllUserPhotos = (
  params: UserPhotos
): string[] => {
  const allUserPhotos = [];
  for (let i = 0; i < params.maxPhoto; i++) {
    allUserPhotos.push(`${process.env.REACT_APP_MEDIA_URL}${params.userId}${i}`);
  }
  return allUserPhotos;
};

export const getClubPhoto = (params: ClubPhoto): string => {
  return `${process.env.REACT_APP_MEDIA_URL}${getValidClubName(params.clubName)}-${params.cityName}`;
};

export const getAllClubPhotos = (
  params: AllClubPhotos
): string[] => {
  const allClubPhotos = [];
  for (let i = 0; i < params.maxPhoto; i++) {
    allClubPhotos.push(
      `${process.env.REACT_APP_MEDIA_URL}${getValidClubName(params.clubName)}-${params.cityName}-${i}`
    );
  }
  return allClubPhotos;
};
